<template lang="pug">
#modal-validacao-territorio
    el-dialog.modal-argentina-consolidacao(
        :visible.sync='show',
        :before-close='closeDialog',
        :title='$t("mensagens.territorio.territorioAr.modal.titulo")',
        :close-on-click-modal='false'
    )
        .body
            h1.titulo {{ $t('mensagens.territorio.territorioAr.modal.textoInicial') }}
            h1.titulo {{ $t('mensagens.territorio.territorioAr.modal.textoFinal') }}
        .footer
            el-button(type='secondary', @click='closeDialog') {{ $t('mensagens.territorio.territorioAr.modal.cancelar') }}
            el-button(type='primary', @click='confirmaConsolidacao') {{ $t('mensagens.territorio.territorioAr.modal.aprovar') }}
</template>

<script>
export default {
    components: {},
    props: {
        show: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            mensagem: ''
        };
    },
    emits: ['close'],
    methods: {
        closeDialog() {
            this.$emit('close');
        },
        confirmaConsolidacao() {
            this.$emit('confirmaConsolidacao');
        }
    }
};
</script>

<style lang="scss">
.modal-argentina-consolidacao {
    .el-dialog {
        .el-dialog__body {
            padding: 0 !important;
            display: flex;
            flex-direction: column;
            .body {
                padding: 18px 20px;
                display: flex;
                flex-direction: column;
                gap: 5px;
                .titulo {
                    font-weight: 400;
                    font-family: Roboto;
                    color: #3b3b3b;
                    padding: 0;
                }
                textarea {
                    box-shadow: 0 0 0 0;
                    border: 1px solid #e0e0e0;
                    outline: 0;
                    border-radius: 5px;
                    padding: 8px;
                    height: 150px;
                    color: #7c7c7c;
                    font-family: Roboto;
                    font-weight: 400;
                    font-size: 14px;
                    &::placeholder {
                        color: #7c7c7c;
                        font-family: Roboto;
                        font-weight: 400;
                        font-size: 14px;
                    }
                }
            }
            .footer {
                margin-top: 10px;
                border-top: 1px solid #e0e0e0;
                padding: 8px 15px;
                display: flex;
                align-items: center;
                justify-content: flex-end;
            }
        }
    }
}
</style>
